module.exports = __webpack_public_path__ + "img/user2.bab6a6c4.png";